/**
 * RESPONSIBILITY: the core tenets, as a strip of cards that go somewhere.
 *
 * The strip is commons/Carousel — the same one the events use — so the rules about when
 * a strip may move are not written twice.
 */
import { idOf } from '@framework/core';
import type { AboutTenetsSection } from '@app/sections';
import { AboutTenetCard } from './AboutTenetCard';
import { Carousel } from '../commons/Carousel';

export function AboutTenets({ c }: { c: AboutTenetsSection }) {
  const tenets = c.tenets ?? [];
  if (tenets.length === 0) return null;

  return (
    <section className="band about-tenets-band">
      <div className="wrap">
        <div className="band-head about-tenets-head">
          {c.eyebrow && <span className="about-kicker">{c.eyebrow}</span>}
          <h2 className="about-h2">{c.heading}</h2>
        </div>
        {c.intro && <p className="lede about-tenets-intro">{c.intro}</p>}

        <Carousel
          count={tenets.length}
          seconds={0}
          prevLabel={c.prevLabel}
          nextLabel={c.nextLabel}
          pauseLabel={c.stripLabel}
          playLabel={c.stripLabel}
          dotsLabel={c.dotsLabel}
        >
          {tenets.map((t, i) => (
            <AboutTenetCard key={idOf(t) || i} t={t} index={i} linkLabel={c.cardLinkLabel} />
          ))}
        </Carousel>
      </div>
    </section>
  );
}
